import { cn } from '@ridemaadi/utils';

/** Official RideMaadi logo variants (see brand guidelines). */
export type LogoVariant = 'banner' | 'header' | 'pageload';

const CONFIG: Record<LogoVariant, { src: string; width: number; height: number; className: string }> = {
  banner: {
    src: '/logo-banner.png',
    width: 1024,
    height: 558,
    className: 'h-[38px] w-auto max-w-[min(200px,55vw)]',
  },
  header: {
    src: '/logo-header.png',
    width: 976,
    height: 253,
    className: 'h-[48px] w-auto max-w-[min(240px,52vw)]',
  },
  pageload: {
    src: '/logo-pageload.png',
    width: 1024,
    height: 723,
    className: 'h-auto w-auto max-w-[min(320px,88vw)]',
  },
};

/** @deprecated Use `variant` - maps legacy sizes to official assets. */
const LEGACY_SIZE: Record<string, LogoVariant> = {
  sm: 'banner',
  md: 'banner',
  lg: 'pageload',
};

export function Logo({
  variant,
  size,
  className,
  priority,
}: {
  /** Header wordmark (~34px). */
  variant?: LogoVariant;
  /** @deprecated Prefer `variant`. */
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  /** LCP hero logo on the public homepage. */
  priority?: boolean;
}) {
  const resolved = variant ?? LEGACY_SIZE[size ?? 'banner'] ?? 'banner';
  const cfg = CONFIG[resolved];

  return (
    <img
      src={cfg.src}
      alt="RideMaadi logo"
      width={cfg.width}
      height={cfg.height}
      className={cn('object-contain', cfg.className, className)}
      decoding={priority ? 'sync' : 'async'}
      loading={priority ? 'eager' : 'lazy'}
      fetchPriority={priority ? 'high' : undefined}
    />
  );
}

/** App icon asset path - PWA / favicon only; never use in UI chrome. */
export const APP_ICON_SRC = '/logo-app.png';
